export default __webpack_public_path__ + "static/media/aircare-banner-2.006802a8.jpg";